module.exports = __webpack_public_path__ + "img/ex.2210c5cf.svg";